import LayautContext from 'Context/ContextLayaut';
import { useContext } from 'react';

const ServiciosChatBot = () => {
    const context = useContext(LayautContext);
    return {
        listaPreguntasBot: context.llamarServidor('ChatBot/listaPreguntasBot', 'POST'),
        crearPreguntaBot: context.llamarServidor('ChatBot/crearPreguntaBot', 'POST'),
        actualizaPreguntaBot: context.llamarServidor('ChatBot/actualizaPreguntaBot', 'POST'),
        cambiarEstatusPreguntaBot: context.llamarServidor('ChatBot/cambiarEstatusPreguntaBot', 'POST'),
        ordenarPreguntaBot: context.llamarServidor('ChatBot/ordenarPreguntaBot', 'POST'),

        listarChatBot: context.llamarServidor('ChatBot/listarChatBot', 'POST')
    };
};

export default ServiciosChatBot;
